import React from 'react';

class EasternTime extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date()
        };
    }
    componentDidMount() {
        this.setState({ date: new Date() });
    }

    render() {
        return (
            <div>
                <h4>Last Refreshed: </h4>
                <h1>{this.state.date.toLocaleString('en-US', {timeZone: 'America/New_York'}).replace(",","").replace(/:.. /," ")}</h1>
            </div>
        );
    }
}

export default EasternTime;